module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume010.5fda5401.webp";